var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lightbulb",
    transform: "translate(-289 -791)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 60,
    height: 60,
    transform: "translate(289 791)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-spiral_bulb",
    transform: "translate(303 791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M24.054,47.954h2.636L30.643,44H20.1",
    transform: "translate(-9.548 12.046)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M28.621,47.543H22.558A3.544,3.544,0,0,1,19,43.985V37H32.179v6.985A3.544,3.544,0,0,1,28.621,47.543Z",
    transform: "translate(-9.896 9.821)",
    fill: "#9fa8da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M19,44.248a3,3,0,0,0,1.318,2.5l11.729-1.713a2.243,2.243,0,0,0,.132-.923V42.4Zm0-5.14v2.636l13.179-2.109V37Z",
    transform: "translate(-9.896 9.821)",
    fill: "#5c6bc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M40.7,29.945a2.661,2.661,0,0,0,.522-5.272L15.14,16.766a2.744,2.744,0,0,0-3.13,2.109A2.772,2.772,0,0,0,14.1,22.037l26.082,7.907Zm0-15.815a2.786,2.786,0,0,0,2.608-2.109,2.772,2.772,0,0,0-2.087-3.163L29.485,5.3,24.269,9.254l15.91,4.876Zm0,7.907a2.786,2.786,0,0,0,2.608-2.109,2.772,2.772,0,0,0-2.087-3.163L15.14,8.858a2.744,2.744,0,0,0-3.13,2.109A2.772,2.772,0,0,0,14.1,14.13l26.082,7.907Z",
    transform: "translate(-11.966 0.378)",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M21.131,34.5a2.63,2.63,0,0,1-2.608-2.636V27.91c.13-2.372-4.043-2.636-4.043-2.636A2.639,2.639,0,0,1,14.741,20c3.26.132,9.259,1.977,9,8.039v3.822A2.63,2.63,0,0,1,21.131,34.5Zm13.041,0a2.63,2.63,0,0,1-2.608-2.636V27.91c0-5.272,5.477-7.38,8.737-7.907a2.742,2.742,0,0,1,3,2.24,2.66,2.66,0,0,1-2.217,3.031c-.913.132-4.3,1.054-4.3,2.636v3.954A2.63,2.63,0,0,1,34.172,34.5Z",
    transform: "translate(-11.958 5.048)",
    fill: "#ffd54f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M14.619,31.314a2.547,2.547,0,0,1-2.478-1.845,2.671,2.671,0,0,1,1.7-3.295l26.082-7.907a2.633,2.633,0,0,1,3.26,1.713,2.671,2.671,0,0,1-1.7,3.295L15.4,31.183A1.639,1.639,0,0,1,14.619,31.314Zm0-15.815a2.635,2.635,0,0,1-.782-5.14L26.356,6.011a2.577,2.577,0,0,1-1.3-2.636A2.638,2.638,0,0,1,27.92,1c6.912.791,7.955,2.636,8.085,4.217.261,2.9-3,3.954-4.173,4.349L15.4,15.236A.952.952,0,0,1,14.619,15.5Zm0,7.907A2.786,2.786,0,0,1,12.01,21.3,2.57,2.57,0,0,1,14.1,18.267L40.179,10.36a2.744,2.744,0,0,1,3.13,2.109A2.57,2.57,0,0,1,41.222,15.5L15.14,23.407Z",
    transform: "translate(-11.966 -0.992)",
    fill: "#ffd54f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M33.389,39.861H20.507c-3.514,0-6.507-3.954-6.507-7.776v-2.9A1.174,1.174,0,0,1,15.171,28H38.725a1.312,1.312,0,0,1,1.3,1.318v2.636C40.026,35.907,37.033,39.861,33.389,39.861Z",
    transform: "translate(-11.319 7.131)",
    fill: "#cfd8dc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.3c55aea541cfcf7942b66ed32a13dc96.svg";
export { ForwardRef as ReactComponent };